const noData = [null, "", undefined, "null"]

const state = {
  residentialLocation: null,
  residentialLocationLoading: false
}

const getters = {
  residentialLocation (state) {
    return state.residentialLocation
  },
  residentialLocationLoading (state) {
    return state.residentialLocationLoading
  }
}

const actions = {
  setResidentialLocation(context, data) {
    context.commit('setResidentialLocation', data)
  },
  residentialLocationLoading(context, data) {
    context.commit('residentialLocationLoading', data)
  }
}

const mutations = {
  setResidentialLocation(state, data) {
    state.residentialLocation = data
  },
  residentialLocationLoading(state, data) {
    state.residentialLocationLoading = data
  },
}

export default {
  state,
  actions,
  mutations,
  getters
}